
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { updataUserInfo, modifyPwd, delAccount, authLogin, deleteWeixin, getUserInfo, changeAdmin, getUserSettings, setUserSettings,quitCompanyDept } from '@/api/users';
import { checkVerifyCode } from '@/api/other';
import { getAddress, editAddress, addAddress, deleteAddress } from '@/api/address';
import { getCompanyInfo, companyList } from '@/api/company';
import { makeKey } from '@/utils/qiniu';

// [AMapReplace->OrderArea 20260825] 原地图选点组件 PickAddressInMap 替换为 OrderArea 省市区选择器
import OrderArea from '@/views/order/components/OrderArea.vue';
import OrderAddressCustom from '../order/components/OrderAddressCustom.vue';
import DialogImgLarge from '@/components/ImgLarge/index.vue';
import DialogSetStaff from '../staff/components/setStaff.vue';
import sendCode from './components/SendCode.vue';
import DialogAddAddress from './components/AddAddress.vue';

import { getQiniuToken } from '@/api/third';
import { Qiniu } from '@/types/qiniu';
import { createOrder } from '@/api/order';

@Component({
  name: 'UserAccount',
  components: {
    OrderArea,
    sendCode,
    DialogImgLarge,
    DialogSetStaff,
    OrderAddressCustom,
    DialogAddAddress
  }
})
export default class extends Vue {
  private qiniu = require('qiniu-js');
  private activeName = 'userSetting';
  private qiniuDomain: string = 'https://up-z1.qiniup.com';
  private form: object = {}; // 上传到七牛的token
  private defaultUrl: string = '';
  // TODO::获取用户信息
  private userInfoName='';
  private userInfoEmail='';
  private userInfoAddress='';

  private userInfo:any=UserModule.getUserInfo;
  private userMobile: any = UserModule.getUserMobile;
  private imageUrl = (UserModule.user as any).head_img;
  private imgKey=''
  private accountUser=UserModule.getAccount;

  private showAddressDialog = false;

  private windowHg = window.innerHeight - 140;

  private addressList: any = [];

  private weiXinList:any=[];
  private isSuperAdmin=false;

  private isCancelAccount=false
  private companyList:any=[];

  private qiniuBean:any={}

  created() {
    this.userInfoName = this.userInfo.name;
    this.userInfoEmail = this.userInfo.email;
    this.userInfoAddress = this.userInfo.address;
    this.$set(this.account, 'power', parseInt((UserModule.userAuthorization as any).is_auth_login) === 1);
    this.weiXinList = (UserModule.getUserInfo as any).wx_bind;
    this.isSuperAdmin = parseInt((UserModule.getCompany as any).super_admin) === 1;
    this.userInfo.addressStr = (UserModule.user as any).province_name === (UserModule.user as any).city_name ? (UserModule.user as any).province_name +
          '  ' + (UserModule.user as any).district_name : (UserModule.user as any).province_name + '  ' + (UserModule.user as any).city_name + '  ' + (UserModule.user as any).district_name;
  
    //tab默认是usersetting
    this.getSetting();
  }

  private dialogFeedbackVisible = false
  private formFeedback: any = {
    content: '',
    img: []
  }
  private feedbackHandle() {
    getQiniuToken({
      type: Qiniu.UPLOAD_TYPE_TROUBLE
    }).then(res => {
      if (res && res.data) {
        this.qiniuBean = res.data;
      }
    });
    this.dialogFeedbackVisible = true;
  }
  private uploadSuccessFeedback(res: any) {
    this.formFeedback.img.push(res.key);
  }
  private beforeUpload(file:any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then(res => {
      let k = makeKey(this.qiniuBean.prekey);
      this.form = {
        key: k,
        token: this.qiniuBean.uptoken,
        domain: this.qiniuBean.domain
      };
    });
  }
  private feedbackConfirm() {
    if (!this.formFeedback.content) {
      this.showErrorMsg('请输入您的宝贵意见')
      return
    }
    let parameters:any = {};
    // 1是自己报，2是替客户报
    parameters['order_create_type'] = '1';
    parameters['order_type'] = '2';
    parameters['address_type'] = 1;

    parameters['user_id'] = UserModule.getUserId;
    parameters['user_name'] = UserModule.getUserName;
    parameters['company_id'] = UserModule.getCompanyId;
    parameters['customer_user_id'] = UserModule.getUserId;
    parameters['customer_user_name'] = UserModule.getUserName;

    parameters['servicer_company_id'] = 15159;
    parameters['servicer_company_name'] = '北京蓝色聚力科技有限公司';

    parameters['trouble_describle'] = this.formFeedback.content;
    if (this.formFeedback.img) {
      parameters['trouble_image'] = this.formFeedback.img.join(',');
    }

    parameters['address'] = (UserModule.getUserInfo && UserModule.getUserInfo.address) ? UserModule.getUserInfo.address : '蓝色聚力';
    parameters['name'] = UserModule.getUserName;
    parameters['mobile'] = UserModule.getUserMobile;
    parameters['phone_num'] = UserModule.getUserPhone;
    createOrder(parameters).then((res:any) => {
      this.showSecussMsg(res.msg)
      this.dialogFeedbackVisible = false
    })
  }
  private imgLargeHandle(val: [], index: number, type: number) {
    let arr = [];
    if (type === 2) {
      let h: any = {};
      h.media_type = type;
      h.video_url = val;
      arr.push(h);
    } else {
      for (let i = 0; i < val.length; i++) {
        arr.push(this.qiniuBean.default_url + val[i]);
      }
    }
    let enlargedData = {
      isShow: true,
      imgList: arr,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  private deleteimg(index: any) {
    this.formFeedback.img.splice(index, 1);
  }
  private handlePictureCardPreview() {

  }
  private handleRemove() {

  }

  // el-tabs 切换
  handleClick(tab: any, event: any) {
    if (tab.name !== 'cancelAccount') {
      this.isCancelAccount = false;
    }
    switch (tab.name) {
      case 'userInfo':
        getQiniuToken({
          type: Qiniu.UPLOAD_TYPE_USER
        }).then(res => {
          if (res && res.data) {
            this.qiniuBean = res.data;
          }
        });
        this.getCompanyList(true);
        break;
      case 'userSetting':
        this.getSetting();
        break;
      case 'userAddress':
        this.getAddress();
        break;
      case 'modifyPwd':
        break;
      case 'modifyMobil':
        break;
      case 'cancelAccount':
        this.getCompanyList(false);
        break;
      case 'adminTransfer':
        break;
    }
  }
  // 获取公司信息

  // -------------------------------个人资料---------------------------------
  // 个人资料保存  邮箱 地址 没有接口

  private isRename = false
  renameConfirm() {
    if (!this.userInfoName) {
      this.showErrorMsg('请输入姓名');
      return
    }
    const params:any = {
      user_id: UserModule.getUserId,
      user_name: this.userInfoName
    }
    updataUserInfo(params)
      .then(res => {
        UserModule.setUserInfo(res.data.user);
        this.showSecussMsg((res as any).msg);
        this.isRename = false
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  private isEmail = false
  emailConfirm() {
    const params:any = {
      user_id: UserModule.getUserId,
      email: this.userInfoEmail
    }
    updataUserInfo(params)
      .then(res => {
        UserModule.setUserInfo(res.data.user);
        this.showSecussMsg((res as any).msg);
        this.isEmail = false
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  quitDeptConfirm(companyId:any, deptId:any){
    this.$msgbox({
      title: '提示',
      showCancelButton: true,
      confirmButtonText: '退出',
      cancelButtonText: '取消',
      message: '确定退出部门?',
      type: 'warning'
    }).then(() => {
      this.quitDept(companyId, deptId);
    })
  }
  quitDept(companyId:any, deptId:any) {
    const params:any = {
      user_id: UserModule.getUserId,
      quit_company_id: companyId,
      quit_dept_id: deptId
    }
    quitCompanyDept(params)
      .then(res => {
        this.showSecussMsg((res as any).msg);
        this.getCompanyList(true);
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  private isAddress = false;
  addressConfirm() {
    const params:any = {
      user_id: UserModule.getUserId,
      province: this.userInfo.province,
      province_name: this.userInfo.province_name,
      city: this.userInfo.city,
      city_name: this.userInfo.city_name,
      district: this.userInfo.district,
      district_name: this.userInfo.district_name,
      latitude: this.userInfo.latitude,
      longitude: this.userInfo.longitude,
      address: this.userInfoAddress,
      adcode: this.userInfo.adcode
    };
    updataUserInfo(params)
      .then(res => {
        UserModule.setUserInfo(res.data.user);
        this.showSecussMsg((res as any).msg);
        this.isAddress = false
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }
  copyNameHandle() {
    (this.$refs.userInfoName as any).select(); // 选择input元素
    document.execCommand("Copy"); // 执行复制命令
  }

  // 选择地址 打开地图dialog
  private addressForAdd:boolean=false;
  areaCilck(val:boolean) {
    this.addressForAdd = val;
    if (val) {
      if (parseInt(this.formAddress.address_type) === 1) {
        this.showAddressDialog = true;
      } else {
        this.areaCustomVisible = true;
      }
    } else {
      this.showAddressDialog = true;
    }
  }

  // [AMapReplace->OrderArea 20260825] 原地图选点回调 positionPicker 改为省市区选择回调 areaSave；
  // OrderArea 仅提供省市区及 adcode，latitude/longitude/address 不再由组件回填
  private saveAreaHandle(area: any) {
    if (area) {
      if (this.addressForAdd) {
        this.formAddress.province_name = area.province_name;
        this.formAddress.province = area.province;
        this.formAddress.city_name = area.city_name;
        this.formAddress.city = area.city;
        this.formAddress.district_name = area.district_name;
        this.formAddress.district = area.district;
        this.$set(this.formAddress, 'addressStr', area.province_name + '  ' + area.city_name + '  ' + area.district_name);
      } else {
        this.userInfo.province_name = area.province_name;
        this.userInfo.province = area.province;
        this.userInfo.city_name = area.city_name;
        this.userInfo.city = area.city;
        this.userInfo.district_name = area.district_name;
        this.userInfo.district = area.district;
        this.userInfo.adcode = area.adcode;
        this.$set(this.userInfo, 'addressStr', area.province_name + '  ' + area.city_name + '  ' + area.district_name);
      }
    }
  }

  // 地图dialog 关闭
  private closeAddress(close: boolean) {
    this.showAddressDialog = close;
  }
  // 上传图片
  beforeAvatarUpload(file: any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then(res => {
      let k = makeKey(this.qiniuBean.prekey);
      this.defaultUrl = (this.qiniuBean as any).default_url;
      this.form = {
        key: k,
        token: this.qiniuBean.uptoken,
        domain: this.qiniuBean.domain
      };
    });
  }
  // 图片上传成功回调
  uploadSuccess(res: any, file: any) {
    this.imageUrl = this.defaultUrl + res.key;
    this.imgKey = res.key;

    const params:any = {
      user_id: UserModule.getUserId,
    };
    if (this.imgKey) {
      params.head_img = this.imgKey;
    }
    updataUserInfo(params)
      .then(res => {
        UserModule.setUserInfo(res.data.user);
        this.showSecussMsg((res as any).msg);
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }
  // 请输入2-10位由字母、中文组成的姓名
  // 验证email
  private checkEmail = (value: any) => {
    if (value) {
      var reg = /^([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (!reg.test(value)) {
        this.showErrorMsg('请输入有效的电子邮箱！');
      }
    }
  };
  // 解绑微信
  private deleteWeixin(val:any) {
    deleteWeixin({ account_id: val.account_id }).then((res: any) => {
      this.showSecussMsg(res.msg);
      getUserInfo({ user_id: UserModule.getUserId, company_id: UserModule.getCompanyId }).then(async res => {
        await UserModule.setLogin(res.data);
        this.weiXinList = (UserModule.getUserInfo as any).wx_bind;
      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // -------------------------------个人资料---------------------------------
  // --------------个人设置---------------

  private userSetting:any = {
    yy: 11
  }

  private getSetting() {
    const params:any = {
      user_id: UserModule.getUserId
    };
    getUserSettings(params).then(res => {
      if (res && res.data) {
        this.userSetting.yy = parseInt(res.data.backend_voice_push);
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }

  private saveSetting() {
    const params:any = {
      user_id: UserModule.getUserId,
      backend_voice_push: this.userSetting.yy
    };
    setUserSettings(params).then(res => {
      this.showSecussMsg('设置成功');
      getUserInfo({ user_id: UserModule.getUserId, company_id: UserModule.getCompanyId }).then(async res => {
        await UserModule.setLogin(res.data);
        location.reload();
      });
    }).catch(err => {
      let msg = err.msg;
    });
  }

  // --------------个人设置---------------

  // -------------------------------我的地址---------------------------------
  getAddress() {
    const params = {
      user_id: UserModule.getUserId
    };
    getAddress(params)
      .then(res => {
        this.addressList = (res as any).data.list;
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }
  setAddressDefault(val: any) {
    const params = {
      user_id: UserModule.getUserId,
      id: val.id,
      is_default: '1'
    };
    editAddress(params)
      .then((res:any) => {
        this.showSecussMsg(res.msg);
        this.getAddress();
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }
  private isEditAddress=false;
  editAddress(val: any) {
    this.formAddress.address_type = val.address_type;
    if (parseInt(val.address_type) === 1) {
      this.formAddress.province = val.province;
      this.formAddress.city = val.city;
      this.formAddress.district = val.district;
      this.formAddress.province_name = val.province_name;
      this.formAddress.city_name = val.city_name;
      this.formAddress.district_name = val.district_name;
      this.formAddress.adcode = 0;
      this.formAddress.longitude = val.longitude;
      this.formAddress.latitude = val.latitude;
      this.$set(this.formAddress, 'addressStr', val.province_name + '  ' + val.city_name + '  ' + val.district_name);
    } else {
      this.formAddress.one_address_id = val.one_address_id;
      this.formAddress.one_address_name = val.one_address_name;
      this.formAddress.two_address_id = val.two_address_id;
      this.formAddress.two_address_name = val.two_address_name;
      this.formAddress.three_address_id = val.three_address_id;
      this.formAddress.three_address_name = val.three_address_name;
      this.$set(this.formAddress, 'addressStr', val.one_address_name + '  ' + val.two_address_name + '  ' + val.three_address_name);
    }
    this.isEditAddress = true;
    this.dialogAddressVisible = true;
    this.formAddress.address_id = val.id;
    this.$set(this.formAddress, 'name', val.name);
    this.$set(this.formAddress, 'address', val.address);
    this.$set(this.formAddress, 'mobile', val.mobile);
    this.$set(this.formAddress, 'telephone', val.phone_num);
  }
  deleteAddress(val: any) {
    const params = {
      id: val.id,
      user_id: UserModule.getUserId
    };
    deleteAddress(params)
      .then(res => {
        this.getAddress();
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  private dialogAddressVisible = false
  private formAddress:any = {}
  private addAddressClick(val: any) {
    this.isEditAddress = false;
    this.formAddress = {
      address_type: 1
    };
    this.dialogAddressVisible = true;
  }
  private closeFormAddress(val: any) {
    this.dialogAddressVisible = val;
  }
  private addAddress(parmas: any) {
    // let parmas:any = {};
    // parmas.user_id = UserModule.getUserId;
    // parmas.address = val.address;
    // parmas.name = val.name;
    // parmas.mobile = val.mobile;
    // parmas.phone_num = val.telephone;
    // parmas.latitude = val.latitude;
    // parmas.longitude = val.longitude;
    // parmas.adcode = val.adcode;

    // if (parseInt(val.address_type) === 3) {
    //   parmas.one_address_id = val.one_address_id;
    //   parmas.one_address_name = val.one_address_name;
    //   parmas.two_address_id = val.two_address_id;
    //   parmas.two_address_name = val.two_address_name;
    //   parmas.three_address_id = val.three_address_id;
    //   parmas.three_address_name = val.three_address_name;
    // } else {
    //   parmas.province = val.province;
    //   parmas.city = val.city;
    //   parmas.district = val.district;
    //   parmas.province_name = val.province_name;
    //   parmas.city_name = val.city_name;
    //   parmas.district_name = val.district_name;
    // }
    if (this.isEditAddress) {
      // parmas.id = val.address_id;
      editAddress(parmas).then(res => {
        this.showSecussMsg((res as any).msg);
        this.dialogAddressVisible = false;
        this.getAddress();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    } else {
      addAddress(parmas).then(res => {
        this.showSecussMsg((res as any).msg);
        this.dialogAddressVisible = false;
        this.getAddress();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }
  // 选择自定义
  private areaCustomVisible = false
  private saveAreaCustomHandle(value:any) {
    this.areaCustomVisible = false;
    if (value) {
      if (value.pBean && value.pBean1) {
        this.formAddress.one_address_name = JSON.parse(value.pBean).address;
        this.formAddress.one_address_id = JSON.parse(value.pBean).id;
        this.formAddress.two_address_name = JSON.parse(value.pBean1).address;
        this.formAddress.two_address_id = JSON.parse(value.pBean1).id;
        this.formAddress.three_address_name = value.address;
        this.formAddress.three_address_id = value.id;
      } else if (value.pBean) {
        this.formAddress.one_address_name = JSON.parse(value.pBean).address;
        this.formAddress.one_address_id = JSON.parse(value.pBean).id;
        this.formAddress.two_address_name = value.address;
        this.formAddress.two_address_id = value.id;
        this.formAddress.three_address_name = '';
        this.formAddress.three_address_id = '0';
      } else {
        this.formAddress.one_address_name = value.address;
        this.formAddress.one_address_id = value.id;
        this.formAddress.two_address_name = '';
        this.formAddress.two_address_id = '0';
        this.formAddress.three_address_name = '';
        this.formAddress.three_address_id = '0';
      }
    }
    this.$set(this.formAddress, 'addressStr', this.formAddress.one_address_name + '  ' + this.formAddress.two_address_name + '  ' + this.formAddress.three_address_name);
  }
  private closeAreaCustomHandle(value:boolean) {
    this.areaCustomVisible = value;
  }
  // -------------------------------我的地址---------------------------------
  // -------------------------------修改密码---------------------------------
  private pwd:any = {
    mobile: UserModule.getUserMobile,
    code: ''
  }
  private dialogModifyPsdVisible = false
  private codePwdInput(val:string) {
    this.pwd.code = val;
  }
  // 验证验证码对错
  private checkVerifyCode(sendType:number, mobile:string, code:string) {
    let map:any = {};
    map.user_id = UserModule.getUserId;
    map.send_type = sendType;
    map.mobile = mobile;
    map.verify_code = code;
    checkVerifyCode(map).then(res => {
      if (res.data) {
        switch (sendType) {
          case 21:
            // this.modifyMobile(res.data.verify_sign);
            break;
          case 22:
            this.modifyNewPwd(res.data.verify_sign);
            break;
          case 25:
            this.cancleAccount(res.data.verify_sign);
            break;
          case 26:
            this.AdminTransfer(res.data.verify_sign);
            break;
        }
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private modifyPwd() {
    if (!this.pwd.mobile) {
      this.showErrorMsg('请输入手机号');
      return;
    }
    if (!this.pwd.code) {
      this.showErrorMsg('请输入验证码');
      return;
    }
    if (!this.pwd.pwd) {
      this.showErrorMsg('请输入新密码');
      return;
    }
    this.checkVerifyCode(22, this.pwd.mobile, this.pwd.code);
    this.dialogModifyPsdVisible = false
  }
  private modifyNewPwd(verifySign:string) {
    let map:any = {};
    map.password = this.pwd.pwd;
    map.mobile = this.pwd.mobile;
    map.verify_sign = verifySign;
    modifyPwd(map).then(res => {
      this.showSecussMsg((res as any).msg);
      this.pwd = {};
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // -------------------------------修改密码---------------------------------
  // -------------------------------修改手机号---------------------------------
  private mobile:any={
    mobile: '',
    code: '',
    imgCode: false
  }
  private dialogModifyMobileVisible = false
  private accountInput(val:string) {
    this.mobile.mobile = val;
  }
  private codeMobileInput(val:string) {
    this.mobile.code = val;
  }
  private codeImg(val: boolean) {
    this.mobile.imgCode = val;
  }
  private modifyMobileClick() {
    if (!this.mobile.mobile) {
      this.showErrorMsg('请输入手机号');
      return;
    }
    if (!this.mobile.code) {
      this.showErrorMsg('请输入验证码');
      return;
    }
    if (!this.mobile.imgCode) {
      this.showErrorMsg('图片验证码错误');
      return;
    }
    this.modifyMobile(this.mobile.code);
    // this.checkVerifyCode(21, this.mobile.mobile, this.mobile.code);
  }
  private modifyMobile(verifyCode:string) {
    let map:any = {};
    map.user_id = UserModule.getUserId;
    map.send_type = '21';
    map.mobile = this.mobile.mobile;
    map.verify_code = verifyCode;
    updataUserInfo(map)
      .then(res => {
        this.showSecussMsg((res as any).msg);
        this.dialogModifyMobileVisible = false
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }
  // -------------------------------修改手机号---------------------------------
  // ----------------------------------注销帐号
  private account:any={
    mobile: UserModule.getUserMobile,
    code: ''
  }
  private codeCancleAccountInput(val:string) {
    this.account.code = val;
  }
  private getCompanyList(moreInfo:boolean) {
    let parameters:any = {};
    parameters.user_id = UserModule.getUserId;
    parameters.need_auth = '1';
    if (moreInfo) {
      parameters.is_need_role_info = '1';
      parameters.is_need_department_info = '1';
    }
    companyList(parameters).then(res => {
      if (res.data) {
        this.companyList = res.data.list.reverse();
        if (this.companyList && this.companyList.length > 0) {
          // this.companyList.forEach((company:any) => {
          //   company.dept = ''
          //   if (company.department_list && company.department_list.length > 0) {
          //     company.department_list.forEach((element:any) => {
          //       company.dept = company.dept + element.name + ','
          //     });
          //     company.dept = company.dept.substring(0, company.dept.length - 1)
          //   } else {
          //     company.dept = '暂无部门'
          //   }
          // });
        }
      }
    }).catch(error => {
      let msg = error.msg;
    });
  }
  private cancleAccountClick() {
    if (!this.account.code) {
      this.showErrorMsg('请输入验证码');
      return;
    }

    const h = this.$createElement;
    this.$msgbox({
      title: '提示',
      showCancelButton: true,
      confirmButtonText: '确定注销',
      cancelButtonText: '取消',
      message: h('span', [
        h('span', '系统检测到您是 '),
        Array.apply(null, this.companyList).map(function(node: any) {
          return h('div', { 'class': 'font-default', 'style': 'margin:5px 0' }, parseInt(node.super_admin) === 1 ? node.name : '');
        }),
        h('span', '的管理员。注销后上述公司将会被除，上述公司所有的人员将会与其解除关系； ')
      ]),
      type: 'warning'
    }).then(() => {
      this.checkVerifyCode(25, this.account.mobile, this.account.code);
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消注销'
      });
    });
  }
  private cancleAccount(code:any) {
    let map:any = {};
    map.user_id = UserModule.getUserId;
    map.company_id = UserModule.getCompanyId;
    map.account_id = UserModule.getAccountId;
    map.mobile = this.account.mobile;
    map.verify_code = code;
    delAccount(map).then((res:any) => {
      this.showSecussMsg(res.msg);
      //腾讯tim停用 20251231
      // (this as any).TIM.logout();
      // (this as any).TIM.destroy();
      try {
        (this as any).NIM.V2NIMLoginService.logout()
      } catch (err) {
        // TODO failed, check code
        // console.log(err.code)
      }
      UserModule.ResetToken();
      window.location.href = location.protocol + process.env.VUE_APP_LOGIN_URL;
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 账户授权
  private authToUS() {
    let map:any = {};
    map.user_id = UserModule.getUserId;
    map.company_id = UserModule.getCompanyId;
    map.is_auth_login = this.account.power ? '1' : '0';
    authLogin(map).then(res => {
      if (res) {
        this.showSecussMsg('操作成功');
        UserModule.setIsAuthLogin(this.account.power ? '1' : '0');
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // ----------------注销帐号
  // ---------转让管理员---------
private admin:any={
  mobile: UserModule.getUserMobile,
  code: ''
}
private codeAdminTransferInput(val:string) {
  this.account.code = val;
}
private formAdmin = {
  name: '',
  id: ''
}
private dialogSelectedStaffVisible = false
private selectdAdmin() {
  this.dialogSelectedStaffVisible = true;
}
private selectedStaffHandle(val: any) {
  this.formAdmin.id = val.id;
  this.formAdmin.name = val.name;
}
private closeStaffHandle(val: any) {
  this.dialogSelectedStaffVisible = val;
}
private adminFinishClick() {
  if (!this.account.code) {
    this.showErrorMsg('请输入验证码');
    return;
  }
  if (!this.formAdmin.id) {
    this.showErrorMsg('请选择人员');
    return;
  }
  this.checkVerifyCode(26, this.account.mobile, this.account.code);
}
private AdminTransfer(code:any) {
  let map:any = {};
  map.user_id = UserModule.getUserId;
  map.company_id = UserModule.getCompanyId;
  map.mobile = this.account.mobile;
  map.code = code;
  map.new_user_id = this.formAdmin.id;
  changeAdmin(map).then(res => {
    getUserInfo({ user_id: UserModule.getUserId, company_id: UserModule.getCompanyId }).then(async res => {
      await UserModule.setLogin(res.data);
      window.location.reload();
    });
    this.showSecussMsg((res as any).msg);
  }).catch(err => {
    this.showErrorMsg(err.msg);
  });
}
// ------------
private showErrorMsg(msg: string) {
  this.$notify({
    title: '提示',
    message: msg,
    offset: 100,
    type: 'error'
  });
}
private showSecussMsg(msg: string) {
  this.$notify({
    title: '提示',
    message: msg,
    offset: 100,
    type: 'success'
  });
}
}
